import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
// Icons
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import WorkIcon from '@mui/icons-material/Work';

export default function LabelBottomNavigation() {
    const [value, setValue] = React.useState('Home');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div
            className='bottomNav'
            style={{
                zIndex: 10,
                position: 'fixed',
                bottom: '6%',
                left: '50%',
                transform: 'translateX(-50%)'
            }}
        >
            <BottomNavigation
                sx={{
                    width: '100%',
                    maxWidth: 500,
                    background: '#8a09f08f',
                    backdropFilter: 'blur(5px)',
                    borderRadius: '15px',
                    zIndex: '99',
                }}
                value={value}
                onChange={handleChange}
            >
                <BottomNavigationAction
                    label="Home"
                    value="Home"
                    icon={<HomeIcon />}
                    aria-label="Home"
                    href="#Home"
                />
                <BottomNavigationAction
                    label="About"
                    value="About"
                    icon={<PersonIcon />}
                    aria-label="About"
                    href="#About"
                />
                <BottomNavigationAction
                    label="Skills"
                    value="Skills"
                    icon={<InsertChartIcon />}
                    aria-label="Skills"
                    href="#Skills"
                />
                <BottomNavigationAction
                    label="Portfolio"
                    value="Portfolio"
                    icon={<WorkIcon />}
                    aria-label="Portfolio"
                    href="#Portfolio"
                />
            </BottomNavigation>
        </div>
    );
}
